// src/components/AdminSidebar/AdminSidebar.jsx
import React, { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './AdminSidebar.css';
// import logo from '../../assets/logo.png';

import { AuthContext } from '../../context/AuthContext';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const AdminSidebar = ({ isUnderMaintenance, toggleMaintenanceMode }) => {
  const location = useLocation();
  const { logout, hasPermission } = useContext(AuthContext);

  // Estado para controlar la visibilidad del submenú de Usuarios y Roles
  const [isUsersSubMenuOpen, setIsUsersSubMenuOpen] = useState(
    location.pathname.startsWith('/admin/users') ||
    location.pathname.startsWith('/admin/roles') ||
    location.pathname === '/admin/profile'
  );

  // Estado para controlar la visibilidad del submenú de Configuración
  const [isConfigSubMenuOpen, setIsConfigSubMenuOpen] = useState(
    location.pathname.startsWith('/admin/system-config') ||
    location.pathname.startsWith('/admin/maintenance') ||
    location.pathname.startsWith('/admin/alerts')
  );

  // Estado para controlar la visibilidad del submenú de Moderación
  const [isModSubMenuOpen, setIsModSubMenuOpen] = useState(
    location.pathname.startsWith('/admin/gallery') ||
    location.pathname.startsWith('/admin/reviews')
  );

  // Estado para controlar la visibilidad del submenú de Solicitudes
  const [isReqSubMenuOpen, setIsReqSubMenuOpen] = useState(
    location.pathname.startsWith('/admin/whitelist') ||
    location.pathname.startsWith('/admin/change-requests')
  );

  // Estado para controlar la visibilidad del submenú de Gestión
  const [isManagementSubMenuOpen, setIsManagementSubMenuOpen] = useState(
    location.pathname.startsWith('/admin/normativas')
  );

  const toggleUsersSubMenu = () => {
    setIsUsersSubMenuOpen(!isUsersSubMenuOpen);
  };

  const toggleConfigSubMenu = () => {
    setIsConfigSubMenuOpen(!isConfigSubMenuOpen);
  };

  const toggleModSubMenu = () => {
    setIsModSubMenuOpen(!isModSubMenuOpen);
  };

  const toggleReqSubMenu = () => {
    setIsReqSubMenuOpen(!isReqSubMenuOpen);
  };

  const toggleManagementSubMenu = () => {
    setIsManagementSubMenuOpen(!isManagementSubMenuOpen);
  };

  const handleLogout = () => {
    logout();
  };

  const panelVersion = "1.2.0-beta";

  return (
    <div className="admin-sidebar">
      <div className="sidebar-header">
        <img src={process.env.PUBLIC_URL + '/logo512.png'} alt="Admin Logo" className="sidebar-logo" />
        <h2>Panel de Administración</h2>
      </div>
      <ul className="sidebar-nav">
        {/* Dashboard */}
        {hasPermission('ver_dashboard') && (
          <li className="sidebar-nav-item">
            <Link
              to="/admin"
              className={`sidebar-nav-link ${location.pathname === '/admin' ? 'active' : ''}`}
            >
              Dashboard
            </Link>
          </li>
        )}

        {/* Solicitudes */}
        {(hasPermission('gestionar_whitelist_solicitudes') || hasPermission('ver_whitelist_solicitudes')) && (
          <li className="sidebar-nav-item">
            <div
              className={`sidebar-nav-link-dropdown ${isReqSubMenuOpen ? 'active' : ''}`}
              onClick={toggleReqSubMenu}
            >
              <span>Solicitudes</span>
              {isReqSubMenuOpen ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            {isReqSubMenuOpen && (
              <ul className="submenu">
                <li>
                  <Link
                    to="/admin/whitelist"
                    className={`submenu-link ${location.pathname === '/admin/whitelist' ? 'active' : ''}`}
                  >
                    Solicitudes Whitelist
                  </Link>
                </li>
                <li>
                  <Link
                    to="/admin/change-requests"
                    className={`submenu-link ${location.pathname === '/admin/change-requests' ? 'active' : ''}`}
                  >
                    Solicitudes Cambios
                  </Link>
                </li>
              </ul>
            )}
          </li>
        )}

        {/* Moderación */}
        {hasPermission('ver_dashboard') && (
          <li className="sidebar-nav-item">
            <div
              className={`sidebar-nav-link-dropdown ${isModSubMenuOpen ? 'active' : ''}`}
              onClick={toggleModSubMenu}
            >
              <span>Moderación</span>
              {isModSubMenuOpen ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            {isModSubMenuOpen && (
              <ul className="submenu">
                <li>
                  <Link
                    to="/admin/gallery"
                    className={`submenu-link ${location.pathname === '/admin/gallery' ? 'active' : ''}`}
                  >
                    Moderación Galería
                  </Link>
                </li>
                <li>
                  <Link
                    to="/admin/reviews"
                    className={`submenu-link ${location.pathname === '/admin/reviews' ? 'active' : ''}`}
                  >
                    Moderación Valoraciones
                  </Link>
                </li>
              </ul>
            )}
          </li>
        )}

        {/* Usuarios y Roles */}
        {(hasPermission('gestionar_usuarios') || hasPermission('ver_usuarios') ||
          hasPermission('gestionar_roles') || hasPermission('ver_roles')) && (
            <li className="sidebar-nav-item">
              <div
                className={`sidebar-nav-link-dropdown ${isUsersSubMenuOpen ? 'active' : ''}`}
                onClick={toggleUsersSubMenu}
              >
                <span>Usuarios y Roles</span>
                {isUsersSubMenuOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {isUsersSubMenuOpen && (
                <ul className="submenu">
                  {hasPermission('ver_dashboard') && (
                    <li>
                      <Link
                        to="/admin/profile"
                        className={`submenu-link ${location.pathname === '/admin/profile' ? 'active' : ''}`}
                      >
                        Mi Perfil
                      </Link>
                    </li>
                  )}
                  {(hasPermission('gestionar_usuarios') || hasPermission('ver_usuarios')) && (
                    <li>
                      <Link
                        to="/admin/users"
                        className={`submenu-link ${location.pathname === '/admin/users' ? 'active' : ''}`}
                      >
                        Gestión de Usuarios
                      </Link>
                    </li>
                  )}
                  {(hasPermission('gestionar_roles') || hasPermission('ver_roles')) && (
                    <li>
                      <Link
                        to="/admin/roles"
                        className={`submenu-link ${location.pathname === '/admin/roles' ? 'active' : ''}`}
                      >
                        Gestión de Roles
                      </Link>
                    </li>
                  )}
                </ul>
              )}
            </li>
          )}

        {/* Gestión */}
        {hasPermission('ver_dashboard') && (
          <li className="sidebar-nav-item">
            <div
              className={`sidebar-nav-link-dropdown ${isManagementSubMenuOpen ? 'active' : ''}`}
              onClick={toggleManagementSubMenu}
            >
              <span>Gestión</span>
              {isManagementSubMenuOpen ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            {isManagementSubMenuOpen && (
              <ul className="submenu">
                <li>
                  <Link
                    to="/admin/normativas"
                    className={`submenu-link ${location.pathname.startsWith('/admin/normativas') ? 'active' : ''}`}
                  >
                    Gestión de Normativas
                  </Link>
                </li>
              </ul>
            )}
          </li>
        )}

        {/* Configuración del Sistema */}
        {hasPermission('activar_modo_mantenimiento') && (
          <li className="sidebar-nav-item">
            <div
              className={`sidebar-nav-link-dropdown ${isConfigSubMenuOpen ? 'active' : ''}`}
              onClick={toggleConfigSubMenu}
            >
              <span>Configuración</span>
              {isConfigSubMenuOpen ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            {isConfigSubMenuOpen && (
              <ul className="submenu">
                <li>
                  <Link
                    to="/admin/maintenance"
                    className={`submenu-link ${location.pathname === '/admin/maintenance' ? 'active' : ''}`}
                  >
                    Modo Mantenimiento
                  </Link>
                </li>
                <li>
                  <Link
                    to="/admin/alerts"
                    className={`submenu-link ${location.pathname === '/admin/alerts' ? 'active' : ''}`}
                  >
                    Gestión de Alertas
                  </Link>
                </li>
              </ul>
            )}
          </li>
        )}

        {/* Logs */}
        {hasPermission('ver_logs') && (
          <li className="sidebar-nav-item">
            <Link
              to="/admin/logs"
              className={`sidebar-nav-link ${location.pathname.startsWith('/admin/logs') ? 'active' : ''}`}
            >
              Logs
            </Link>
          </li>
        )}
      </ul>
      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-button">
          Cerrar Sesión
        </button>
        <p>&copy; Rias baixas PD | Admin</p>
        <p className="panel-version">Versión: {panelVersion}</p>
      </div>
    </div>
  );
};

export default AdminSidebar;